window.easyConstants = {
    agileSwimlanesGroupByParameter: "kanban_swimlanes_group_by_parameter"
};